import React from 'react';
import { Col } from 'react-bootstrap';
import './styles/terms-and-conditions.css';

function Privacy() {
  return (
    <Col xs={12} lg={90} xl={900} className="mx-auto">
      <div className="terms-and-conditions-content">
        <h2 className="text-center mb-4 stylish-heading">
          Privacy Policy
        </h2>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">PRIVACY POLICY OF HARUSI.ONLINE</h2>
          <p className="terms-and-conditions-section-text">
            Harusionline is committed to protecting its users' privacy. We do not give, sell, share or disclose information about your individual visits or personal information that you may provide such as your name, address, email address or telephone number, to anyone outside Harusi.online for any reason whatsoever EXCEPT when required by law, or with the user's express permission. For protecting the personal information submitted to us, we ensure that our standards are fully in line and compatible with the generally accepted industry standards and best practices. All the data on the Website is stored on a secure server with Linode. Nevertheless, it is also admitted that no method of transmission over the Internet, or electronic storage methods are completely secure.
          </p>
        </section>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">INFORMATION WE COLLECT</h2>
          <p className="terms-and-conditions-section-text">
            To provide you with our event management, digital e-cards, guest coordination, and notification services, Harusi Online collects the following types of information:
          </p>
          <p className="terms-and-conditions-section-text mt-2">
            • <strong>Personal Identification Data:</strong> Full name, mobile phone number, email address, and account login credentials.
          </p>
          <p className="terms-and-conditions-section-text mt-2">
            • <strong>Event Data:</strong> Event titles, descriptions, event dates, venue locations, invitation intros/infos, and guest list details submitted by event organizers.
          </p>
       
        </section>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">HOW WE USE YOUR INFORMATION</h2>
          <p className="terms-and-conditions-section-text">
            We use the information we collect strictly to deliver, improve, and protect our services, including:
          </p>
          <p className="terms-and-conditions-section-text mt-2">
            • Creating and managing your user account and event dashboards.
          </p>
          <p className="terms-and-conditions-section-text mt-2">
            • Generating and delivering digital invitations (E-cards) and event websites.
          </p>
          <p className="terms-and-conditions-section-text mt-2">
            • Sending essential SMS, WhatsApp messages, and notifications to event guests on your request.
          </p>
          <p className="terms-and-conditions-section-text mt-2">
            • Verifying user identity via One-Time Passwords (OTP) upon authentication.
          </p>
          <p className="terms-and-conditions-section-text mt-2">
            • Processing transactions for SMS credits, premium e-card templates, and service fees.
          </p>
          <p className="terms-and-conditions-section-text mt-2">
            • Providing customer support and investigating reported technical issues or fraud.
          </p>
        </section>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">DATA PROTECTION & SECURITY</h2>
          <p className="terms-and-conditions-section-text">
            We implement robust security measures to prevent unauthorized access, alteration, disclosure, or destruction of your personal data. All data transmitted between your device and Harusi Online is encrypted using Secure Sockets Layer (SSL/TLS) protocols. Data is stored on enterprise-grade secure servers maintained with Linode and digital infrastructure with restricted access control.
          </p>
        </section>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">INFORMATION SHARING & THIRD PARTIES</h2>
          <p className="terms-and-conditions-section-text">
            Harusi Online does NOT sell, rent, or trade your personal information to third parties for marketing purposes. We only share information with trusted third-party service providers (such as telecommunication SMS gateways and licensed payment processors like Pesapal) solely to execute transactions and deliver messages requested by you. These third parties are bound by strict confidentiality agreements.
          </p>
        </section>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">USER RIGHTS & DATA DELETION REQUESTS</h2>
          <p className="terms-and-conditions-section-text">
            You have full control over your personal data. You can view and update your personal details and event data at any time via your account settings.
          </p>
          <p className="terms-and-conditions-section-text mt-2">
            You have the right to request permanent deletion of your account and associated personal data. You can initiate account deletion directly within the Account Settings tab in our application or submit a written erasure request to our support team at info@sj.co.tz . Upon request, your account and associated personal records will be permanently removed within 30 days.
          </p>
        </section>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">COOKIES & LOCAL STORAGE</h2>
          <p className="terms-and-conditions-section-text">
            We use cookies and browser local storage tokens strictly for session management, authentication security, and maintaining your selected event context across pages. You can disable cookies in your browser settings, though some interactive features may not function optimally as a result.
          </p>
        </section>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">CHILDREN'S PRIVACY</h2>
          <p className="terms-and-conditions-section-text">
            Harusi Online services are intended for adult event organizers and attendees. We do not knowingly solicit or collect personal data from children under the age of 13.
          </p>
        </section>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">CHANGES TO THIS PRIVACY POLICY</h2>
          <p className="terms-and-conditions-section-text">
            We reserve the right to modify this Privacy Policy at any time. Any changes will be published immediately on this page. We encourage users to review this page periodically to remain informed about how we protect their information.
          </p>
        </section>

        <section className="terms-and-conditions-section">
          <h2 className="terms-and-conditions-section-title">CONTACT INFORMATION</h2>
          <p className="terms-and-conditions-section-text">
            If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at SJ Softwares & Consultancy (Harusi Online), Email: info@sj.co.tz / harusidotonline@gmail.com, Website: https://harusi.online/.
          </p>
        </section>
      </div>
    </Col>
  );
}

export default Privacy;
